import type { PublicUser } from '@evi/shared';

export const SALES_BOOK_WIDGETS = ['book_locations', 'book_partners', 'book_sessions', 'book_energy'] as const;
export const SALES_DASHBOARD_DEFAULTS = [
  ...SALES_BOOK_WIDGETS, 'chart_network', 'alerts', 'start_timeouts',
] as const;
export const SALES_DASHBOARD_ALLOWED = new Set<string>([
  ...SALES_DASHBOARD_DEFAULTS, 'kpi_sessions', 'kpi_energy', 'charger_uptime',
  'session_trends', 'charger_utilization',
]);

/** Apply on load AND render, including layouts saved by a different persona. */
export function dashboardWidgetAllowed(id: string, salesBook: boolean): boolean {
  return salesBook ? SALES_DASHBOARD_ALLOWED.has(id) : !SALES_BOOK_WIDGETS.some(w => w === id);
}

/** Cached responses must never cross an account, tenant or persona change. */
export function dashboardQueryIdentity(user: Pick<PublicUser, '_id' | 'tenant_id' | 'role' | 'template'> | null): string {
  return user ? JSON.stringify([user._id, user.tenant_id, user.role, user.template ?? null]) : 'signed-out';
}
